import { get } from "./get"
import { responseData } from "./responseData"

export const getData = responseData(get)
